type ComputedStyles = {
  [key: string]: React.CSSProperties;
}

export const getStyles = (): ComputedStyles => ({
  bannerContainer: {
    zIndex: 2000,
    left: '50%',
    right: '50%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  top: {
    position: 'relative',
  },

  bottom: {
    left: 0,
    right: 0,
    bottom: 0,
    margin: 0,
    position: 'fixed',
  }
});
